import { render, staticRenderFns } from "./Catalogs.vue?vue&type=template&id=37b88ce2&scoped=true"
import script from "./Catalogs.vue?vue&type=script&lang=js"
export * from "./Catalogs.vue?vue&type=script&lang=js"
import style0 from "./Catalogs.vue?vue&type=style&index=0&id=37b88ce2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b88ce2",
  null
  
)

export default component.exports